import Grid from "@mui/material/Grid";
import { 
  CmpButton,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

 
import GCAutocompleteCheckbox from "./GCAutocompleteCheckbox";
import { Set_LoadingList_HeadLoadingListUser } from "../SliceLoadingList";
import { CmpDatePickerField001V1, CmpSelectArrFieldV1, CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCHead({
  vRdxLoadingListUser,
  dispatch,
  vRdxWmsHead,
  fGrnType,
  sDocLoadingGrnType,
  xErrorMsg,
  xDisableBasedOnGridDataLength,
  fGrnDate,
  sClusterArr,
  fCluster,
  fLocation,
  vRdxuserLoc,
  fLoadingType,
  sLoadingTypeArr,
  fTransaction,
  sTransactionArr,
  fTruck,
  sTruckArr,
  fUnloadingBay,
  sUnloadingBayArr,
  fDriver,
  fDriverEnter,
  sLoadingListCheckboxArr,
  fLoadingListCheckBox,
  fLoad_Release,
  inputFocus,
  //customer
  xfGC_Toggle_Head_Customer_Name,
  xGC_Toggle_Head_Customer_Toggle = false,
  xGC_Toggle_Head_Customer_onKeyUp,
  xGC_Toggle_Head_Customer_SearchDropdownObj,
  xGC_Toggle_Head_Customer_Dropdown_onChange,
  xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load,
  xGC_Toggle_Head_Customer_GridColumns,
  xGC_Toggle_Head_Customer_GridData,
  xfGC_Toggle_Head_Customer_OnRowClick,
  xfGC_Toggle_Head_Customer_OnCellKeyDown,
  xGC_Toggle_Head_Customer_DropDown_Arr,
  //customer end
}) {
  console.log(sLoadingListCheckboxArr);
  
  return (
    <form id="WmsLoadingListHead">
      <Grid
        container
        rowSpacing={{xs: 0.8, sm: 0.9, md: 0 }}
        columnSpacing={{xs: 0.9, sm: 0.9, md: 0.6  }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
             
            <Grid item xs={12} sm={3} md={12} >
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxWmsHead.A_VocTyp}
                xOnChange={fGrnType}
                xName={"A_VocTyp"}
                xData={sDocLoadingGrnType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocTyp}
                xDisable={xDisableBasedOnGridDataLength || vRdxWmsHead.A_VocNo!=0}
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid>
             
            <Grid item xs={12} sm={3} md={12}  >
              <CmpTextFieldV1
                 xLabelText="Doc.No"
                xValue={vRdxWmsHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocNo}
              />
            </Grid>
           
            <Grid item xs={6} sm={3} md={12} >
              <CmpDatePickerField001V1
               xLabelText="Doc Date"
                xtabIndex={"2"}
                // xValue={vRdxWmsHead.A_PostDt}
                xValue={vRdxWmsHead.A_PostDt}
                xOnChange={fGrnDate}
                xName={"A_PostDt"}
                xError={xErrorMsg.A_PostDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_PostDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_RefDocNo");
                // }}
              />
            </Grid>
           
            <Grid item xs={6} sm={3} md={12}  >
              <CmpSelectFieldV1
                xtabIndex={"3"}
                xLabelText="Cluster"
                xValue={vRdxWmsHead.Cluster}
                xOnChange={fCluster}
                xName={"Cluster"}
                xData={sClusterArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Cluster === "" ? false : true}
                xErrorMessage={xErrorMsg.Cluster}
                xDisable={xDisableBasedOnGridDataLength}
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Grid
            container
            spacing={0.9}
            columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
           
            <Grid item xs={6} sm={6} md={6}  >
              <CmpSelectFieldV1
                xtabIndex={"5"}
                xLabelText="Location"
                xValue={vRdxWmsHead.A_Loc}
                xOnChange={fLocation}
                xName={"A_Loc"}
                xData={vRdxuserLoc}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_Loc === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Loc}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>
            
            <Grid item xs={6} sm={6} md={6}>
              <CmpSelectArrFieldV1
                xtabIndex={"6"}
                xLabelText="Loading Type"
                xValue={vRdxWmsHead.A_Type}
                xOnChange={fLoadingType}
                xName={"A_Type"}
                xData={sLoadingTypeArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_Type === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Type}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>
           
            <Grid item xs={12} sm={12} md={12}  >
              <Grid container spacing={0.9}>
                <Grid item xs={3} sm={2} md={3} >
                <CmpTextFieldV1
                        xLabelText="Party/Loc"
                    xValue={vRdxWmsHead.A_Party}
                    xType={"text"} // text/number/password
                    xName={"A_Party"}
                    xReadOnly={true}
                    xOnChange={""}
                    xError={xErrorMsg.A_Party === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_Party}
                  />
                </Grid>
                <Grid item xs={9} sm={10} md={9} >
                   <GCToggleSearchV1
                      xLabelText="Customer Name"
                    xName={"GC_Toggle_Head_Customer_Name"}
                    xType={"text"}
                    xValue={vRdxWmsHead.A_PartyName}
                    xReadOnly={false}
                    xOnChange={xfGC_Toggle_Head_Customer_Name} //GCToggleSearch onchange main input
                    xOnKeyUp={xGC_Toggle_Head_Customer_onKeyUp} //GCToggleSearch xOnKeyUp main input
                    xError={xErrorMsg.A_PartyName === "" ? false : true}
                    xErrorMessage={xErrorMsg.A_PartyName}
                    xMediaQuery={false}
                    xonClickbtn={xGC_Toggle_Head_Customer_onKeyUp} // GCToggleSearch onclick icon open div on main screen
                    xrows={xGC_Toggle_Head_Customer_GridData} //GCToggleSearch-grid
                    xcolumns={xGC_Toggle_Head_Customer_GridColumns} //GCToggleSearch-grid
                    xRowCellClick={xfGC_Toggle_Head_Customer_OnCellKeyDown}
                    xRowClick={xfGC_Toggle_Head_Customer_OnRowClick}
                    xToggle={xGC_Toggle_Head_Customer_Toggle} //GCToggleSearch- true/false
                    xData={xGC_Toggle_Head_Customer_DropDown_Arr} //GCToggleSearch-select
                    xOnChangeDropdownInput={
                      xGC_Toggle_Head_Customer_Dropdown_onChange
                    } //GCToggleSearch -input
                    xDropdownObj={xGC_Toggle_Head_Customer_SearchDropdownObj} //GCToggleSearch -obj
                    xOnKeyUpDropdownInput={
                      xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
                    } //GCToggleSearch -Enter key and clickc detect
                    xtabIndex="4"
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid item xs={3} sm={2} md={2} lg={2}>
              <CmpInputField
                xValue={vRdxWmsHead.A_Party}
                xType={"text"} // text/number/password
                xName={"A_Party"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_Party === "" ? false : true}
                xErrorMessage={xErrorMsg.A_Party}
              />
            </Grid>
            <Grid item xs={6} sm={8} md={8} lg={8}>
              <GCToggleSearch
                xName={"GC_Toggle_Head_Customer_Name"}
                xType={"text"}
                xValue={vRdxWmsHead.A_PartyName}
                xReadOnly={false}
                xOnChange={xfGC_Toggle_Head_Customer_Name} //GCToggleSearch onchange main input
                xOnKeyUp={xGC_Toggle_Head_Customer_onKeyUp} //GCToggleSearch xOnKeyUp main input
                xError={xErrorMsg.A_PartyName === "" ? false : true}
                xErrorMessage={xErrorMsg.A_PartyName}
                xMediaQuery={false}
                xonClickbtn={xGC_Toggle_Head_Customer_onKeyUp} // GCToggleSearch onclick icon open div on main screen
                xrows={xGC_Toggle_Head_Customer_GridData} //GCToggleSearch-grid
                xcolumns={xGC_Toggle_Head_Customer_GridColumns} //GCToggleSearch-grid
                xRowCellClick={xfGC_Toggle_Head_Customer_OnCellKeyDown}
                xRowClick={xfGC_Toggle_Head_Customer_OnRowClick}
                xToggle={xGC_Toggle_Head_Customer_Toggle} //GCToggleSearch- true/false
                xData={xGC_Toggle_Head_Customer_DropDown_Arr} //GCToggleSearch-select
                xOnChangeDropdownInput={
                  xGC_Toggle_Head_Customer_Dropdown_onChange
                } //GCToggleSearch -input
                xDropdownObj={xGC_Toggle_Head_Customer_SearchDropdownObj} //GCToggleSearch -obj
                xOnKeyUpDropdownInput={
                  xGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load
                } //GCToggleSearch -Enter key and clickc detect
                xtabIndex="4"
              />
            </Grid> */}

           
            <Grid item xs={12} sm={3} md={4} lg={4}>
              <CmpSelectFieldV1
                xtabIndex={"7"}
                xLabelText="Transaction"
                xValue={vRdxWmsHead.Transaction}
                xOnChange={fTransaction}
                xName={"Transaction"}
                xData={sTransactionArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Transaction === "" ? false : true}
                xErrorMessage={xErrorMsg.Transaction}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>
 
            <Grid item xs={12} sm={3} md={4} lg={4}>
              <CmpSelectFieldV1
                xtabIndex={"8"}
                xLabelText="Truck"
                xValue={vRdxWmsHead.Truck}
                xOnChange={fTruck}
                xName={"Truck"}
                xData={sTruckArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.Truck === "" ? false : true}
                xErrorMessage={xErrorMsg.Truck}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>
            
            <Grid item xs={12} sm={3} md={4} lg={4}>
              <CmpSelectFieldV1
                xtabIndex={"9"}
                xLabelText="Loading Bay"
                xValue={vRdxWmsHead.UnloadingBay}
                xOnChange={fUnloadingBay}
                xName={"UnloadingBay"}
                xData={sUnloadingBayArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.UnloadingBay === "" ? false : true}
                xErrorMessage={xErrorMsg.UnloadingBay}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>
            
            <Grid item xs={12} sm={3} md={4} lg={4}>
              <CmpTextFieldV1
               xLabelText="Driver"
                xtabIndex={"10"}
                xValue={vRdxWmsHead?.DriverName}
                xType={"text"} // text/number/password
                xName={"DriverName"}
                xReadOnly={true}
                xOnChange={fDriver}
                xOnKeyUp={fDriverEnter}
                xError={xErrorMsg.DriverName === "" ? false : true}
                xErrorMessage={xErrorMsg.DriverName}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
        <GCAutocompleteCheckbox
        
                xtabIndex={"02"}
                options={sLoadingListCheckboxArr}
                xDisabled={
                 false
                }
                xValue={vRdxLoadingListUser} 
                setValue={ async (value) => {
                  console.log("value", value);
                  
                  dispatch(Set_LoadingList_HeadLoadingListUser(value)) 
                  // setHeadObject((obj) => ({
                  //   ...obj,
                  //   sLocationArr: value, 
                  // }));
                  
                }}
              />
          {/* {sLoadingListCheckboxArr.length > 0 ? (
            <Grid
              container
              spacing={0}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className="align-items-start justify-content-start checkBoxList"
            >
              {sLoadingListCheckboxArr?.map((obj, index) => (
                <Grid item xs={4} sm={3} md={6} lg={6} key={index}>
                  <CmpCheckboxField
                    xChecked={obj?.Flag == "Y"}
                    xOnChange={fLoadingListCheckBox}
                    xDisabled={false}
                    xName={obj?.UId}
                    xNameField={obj?.Name1}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid
              container
              spacing={0}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className="align-items-start justify-content-start checkBoxList"
            >
              <Grid item xs={4} sm={3} md={6} lg={6}>
                <CmpCheckboxField
                  xChecked={false}
                  xOnChange={""}
                  xDisabled={true}
                  xName={"dummycheckbox"}
                  xNameField={""}
                  xError={false}
                  xErrorMessage={""}
                />
              </Grid>
            </Grid>
          )} */}

          <Grid
            container
            spacing={0}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className="align-items-start justify-content-start mt-1"
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={"text-center"}
            >
              <CmpButton
                xbtnName="Load/Release"
                xOnClick={fLoad_Release}
                xVariant="contained"
                xDisabled={vRdxWmsHead.A_DocStat === "POST"}
                xSize="small"
                xjustifyContent="justify-centent-center"
                xSendIcon={""}
              />
            </Grid>
          </Grid>
        </Grid>
        
      </Grid>
    </form>
  );
}
